import { SupplyCategory } from '@ebalance/proto/bfftypes/v1/supply_category_pb'

import { routePaths } from '~/routes/routePaths'

/**
 * 区分 → 元データを管理する画面 の対応表 (design `supply/48data.html` の `CAT_SOURCE`)。
 * 表に無い区分は導線を出さない (= design の `a.hidden = !s` と同じ)。
 */
export const SOURCE_LINK_BY_CATEGORY: Partial<
  Record<
    SupplyCategory,
    {
      path: string
      /** 単独の導線ボタン用 (「〜を開く」)。 サイドバーが使う。 */
      labelKey: string
      /**
       * **文中に埋める時**の表記 (= 画面名そのもの)。
       *
       * 「〜を開く」 は文の途中に置くと「取引契約管理を開くで契約を登録すると」 の
       * ように壊れる。 空状態の案内は説明文とリンクが 1 続きの文になる形なので、
       * 画面名だけを使う (デザイナー指摘 2026-09-01「説明文と導線が自然に繋がる
       * ようにしたい」)。
       */
      nameKey: string
    }
  >
> = {
  [SupplyCategory.BILATERAL]: {
    path: routePaths.supplyBilateral.path,
    labelKey: 'page:supply48Data.filter.sourceLinkBilateral',
    nameKey: 'common:route.supplyBilateral',
  },
  // 常時BU は独立区分にせず相対取引に含める (AC-S4D-001、 判断 2026-07-31 / #4335)
  [SupplyCategory.BACKUP_REGULAR]: {
    path: routePaths.supplyBilateral.path,
    labelKey: 'page:supply48Data.filter.sourceLinkBilateral',
    nameKey: 'common:route.supplyBilateral',
  },
  [SupplyCategory.FUTURES]: {
    path: routePaths.supplyBilateral.path,
    labelKey: 'page:supply48Data.filter.sourceLinkBilateral',
    nameKey: 'common:route.supplyBilateral',
  },
  [SupplyCategory.MARKET]: {
    path: routePaths.biddingSpotPrice.path,
    labelKey: 'page:supply48Data.filter.sourceLinkMarket',
    nameKey: 'common:route.biddingSpotPrice',
  },
}

/**
 * その区分の 48 点データを **CSV で投入できるか**。
 *
 * - **先物は不可**。 `admin/data/uploads/supply-48-data.md` AC-SUPPLY-018 (#5736) が
 *   「取引の受渡区分が先物 (EEX / TOCOM / ICE / スワップ) の行はエラーとして拒否する」
 *   と定める。 先物は保有量確認のみで画面上も read-only、 保有量は**相対取引契約の
 *   登録から自動派生**するのが正規経路 (`supply-48-data.md` AC-S4D-001)
 * - **市場も不可**。 市場区分の行は市場約定由来のみで、 コマ単位の手動投入経路を持たない
 *
 * 空状態の案内で「CSV で入れられます」 と誤って言わないために使う。
 */
export const CSV_UPLOADABLE_CATEGORIES: ReadonlySet<SupplyCategory> = new Set([
  SupplyCategory.BILATERAL,
  SupplyCategory.BACKUP_REGULAR,
])
